import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AutoCompleteModule, ComboBoxModule, MultiSelectModule } from '@syncfusion/ej2-angular-dropdowns';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { TooltipModule } from "@syncfusion/ej2-angular-popups";
import { DropDownButtonModule } from '@syncfusion/ej2-angular-splitbuttons';
import { UtilsModule } from '../../utils/utils.module';
import { EparcoursValidatorsModule } from '../../validators/validators-with-message/eparcours-validators/eparcours-validators.module';
import { MultiselectorModule } from '../multiselect/multiselector.module';
import { NavBarComponent } from '../nav-bar/nav-bar.component';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { AddNewItemChecklistComponent } from './check-list/add-new-item-checklist/add-new-item-checklist.component';
import { ChecklistComponent } from './check-list/checklist.component';
import { ItemChecklistComponent } from './check-list/item-checklist/item-checklist.component';
import { AvatarComponent } from './components/avatar/avatar.component';
import { FormBlocComponent } from './components/form-bloc/form-bloc.component';
import { HeuresMinutesEditComponent } from './components/heures-minutes-edit/heures-minutes-edit.component';
import { FormFieldComponent } from './components/mise-en-page/form-field/form-field.component';
import { MiseEnAvantChipComponent } from './components/mise-en-page/mea/mise-en-avant-chip.component';
import { MiseEnAvantComponent } from './components/mise-en-page/mise-en-avant/mise-en-avant.component';
import { MenuActionDirective } from './components/mise-en-page/page/page-base/directives/menu-action.directive';
import { PageAnchorDirective } from './components/mise-en-page/page/page-base/directives/page-anchor.directive';
import { PageAnimationDirective } from './components/mise-en-page/page/page-base/directives/page-animation.directive';
import { PageButtonsDirective } from './components/mise-en-page/page/page-base/directives/page-buttons.directive';
import { NavbarRightComponent } from './components/mise-en-page/page/page-base/navbar-right/navbar-right.component';
import { PageBodyComponent } from './components/mise-en-page/page/page-base/page-body.component';
import { PageHeaderComponent } from './components/mise-en-page/page/page-base/page-header/page-header.component';
import { PageComponent } from './components/mise-en-page/page/page/page.component';
import { SearchFieldComponent } from './components/mise-en-page/search-field/search-field.component';
import { View360Component } from './components/mise-en-page/view360/view360.component';
import { View360itemComponent } from './components/mise-en-page/view360/view360item/view360item.component';
import { SelectEntitesComponent } from './components/select-entites/select-entites.component';
import { CriteresSelectorMultiComponent } from './criteres-selector-multi/criteres-selector-multi.component';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { ReactiveElementDirective } from './directives/reactive-element.directive';
import { EntiteSelectorComponent } from './entite-selector/entite-selector.component';
import { EntiteSelectorMultiComponent } from './entites-selector-multi/entite-selector-multi.component';
import { IdStringAutoCompleteComponent } from './idstring-autocomplete/idstring-autocomplete.component';
import { SelecteurModelePublipostageComponent } from './selecteur-modele-publipostage/selecteur-modele-publipostage.component';
import { SwitchComponent } from './switch/switch.component';

@NgModule({
  declarations: [
    FormBlocComponent,
    PageBodyComponent,
    PageHeaderComponent,
    View360Component,
    NavBarComponent,
    PageAnchorDirective,
    NavbarRightComponent,
    View360itemComponent,
    MiseEnAvantComponent,
    MiseEnAvantChipComponent,
    PageComponent,
    SearchFieldComponent,
    PageButtonsDirective,
    SearchFieldComponent,
    PageAnimationDirective,
    MenuActionDirective,
    FormFieldComponent,
    SelectEntitesComponent,
    ReactiveElementDirective,
    SwitchComponent,
    AutocompleteComponent,
    IdStringAutoCompleteComponent,
    ClickOutsideDirective,
    HeuresMinutesEditComponent,
    SelecteurModelePublipostageComponent,
    AvatarComponent,
    EntiteSelectorComponent,
    ChecklistComponent,
    ItemChecklistComponent,
    AddNewItemChecklistComponent,
    CriteresSelectorMultiComponent,
    EntiteSelectorMultiComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    DropDownButtonModule,
    ReactiveFormsModule,
    MultiSelectModule,
    MatFormFieldModule,
    AutoCompleteModule,
    ComboBoxModule,
    GridModule,
    UtilsModule,
    MultiselectorModule,
    DragDropModule,
    EparcoursValidatorsModule,
    TooltipModule,
  ],
  exports: [
    FormBlocComponent,
    PageBodyComponent,
    View360Component,
    NavBarComponent,
    PageAnchorDirective,
    View360itemComponent,
    MiseEnAvantComponent,
    MiseEnAvantChipComponent,
    PageComponent,
    SearchFieldComponent,
    MiseEnAvantComponent,
    MiseEnAvantChipComponent,
    View360itemComponent,
    PageButtonsDirective,
    PageAnimationDirective,
    MenuActionDirective,
    FormFieldComponent,
    SelectEntitesComponent,
    ReactiveElementDirective,
    AutocompleteComponent,
    SwitchComponent,
    PageHeaderComponent,
    ClickOutsideDirective,
    HeuresMinutesEditComponent,
    SelecteurModelePublipostageComponent,
    AvatarComponent,
    EntiteSelectorComponent,
    EntiteSelectorMultiComponent,
    ChecklistComponent,
    IdStringAutoCompleteComponent,
    CriteresSelectorMultiComponent,
  ],
  providers: [Title],
})
export class EparcoursComponentsModule {}
